import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * One-time "we've updated our legal terms" acceptance modal. Shows on login
 * when the user hasn't accepted the current version of any document flagged
 * requires_acceptance. Posts acceptance and dismisses.
 */
const LegalUpdateBanner = ({ user }) => {
  const navigate = useNavigate();
  const [pending, setPending] = useState([]);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!user) { setPending([]); return; }
    let alive = true;
    fetch(`${BACKEND_URL}/api/legal/pending-acceptance`)
      .then((r) => (r.ok ? r.json() : { pending: [] }))
      .then((d) => { if (alive) setPending(d.pending || []); })
      .catch(() => {});
    return () => { alive = false; };
  }, [user]);

  if (!user || pending.length === 0) return null;

  const accept = async () => {
    setSubmitting(true);
    try {
      await fetch(`${BACKEND_URL}/api/legal/accept`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ slugs: pending.map((p) => p.slug) }),
      });
      setPending([]);
    } catch { setSubmitting(false); }
  };

  return (
    <div data-testid="legal-update-modal" style={{ position: 'fixed', inset: 0, zIndex: 3000, background: 'rgba(26,32,44,0.6)', backdropFilter: 'blur(4px)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
      <div style={{ background: '#2C3A4C', border: '1px solid rgba(215,179,119,0.35)', borderRadius: '16px', padding: '28px', maxWidth: '460px', width: '100%', boxShadow: '0 20px 60px rgba(0,0,0,0.4)' }}>
        <h2 style={{ fontFamily: 'DM Serif Display, serif', color: '#D7B377', fontSize: '22px', margin: '0 0 10px' }}>We've updated our terms</h2>
        <p style={{ color: '#CBD5E0', fontSize: '15px', lineHeight: 1.6, margin: '0 0 14px' }}>
          We've made changes to the following. Please review and accept to continue.
        </p>
        <ul style={{ margin: '0 0 20px', paddingLeft: '18px' }}>
          {pending.map((p) => (
            <li key={p.slug} style={{ margin: '6px 0' }}>
              <a data-testid={`legal-review-${p.slug}`} href={`/${p.slug}`} target="_blank" rel="noopener noreferrer" style={{ color: '#F7F3E9', fontWeight: 600 }}>{p.title} →</a>
            </li>
          ))}
        </ul>
        <button
          data-testid="legal-accept-btn"
          onClick={accept}
          disabled={submitting}
          style={{ width: '100%', padding: '14px', borderRadius: '12px', border: 'none', cursor: submitting ? 'wait' : 'pointer', background: 'linear-gradient(135deg,#D7B377,#E2D7C4)', color: '#1A202C', fontWeight: 800, fontSize: '15px' }}
        >
          {submitting ? 'Saving…' : 'I Accept'}
        </button>
      </div>
    </div>
  );
};

export default LegalUpdateBanner;
